import { Container, Text, Button } from 'theme-ui';
import { Link } from 'gatsby';
import clampBuilder from '~/utils/clamp-builder';
import { Dispatch, SetStateAction } from 'react';

type Props = {
  setCookiesMessageDismissed: Dispatch<SetStateAction<boolean>>;
  isVisible: boolean;
};

const CookiesMessage = ({ setCookiesMessageDismissed, isVisible }: Props) => {
  return (
    <Container
      variant="fullwidth"
      sx={{
        position: 'fixed',
        display: 'flex',
        left: 0,
        right: 0,
        bottom: isVisible ? 0 : ['-4.8rem', '-5.6rem'],
        zIndex: 100000,
        height: ['4.8rem', '5.6rem'],
        color: 'white',
        backgroundColor: 'rgba(0,0,0,0.6)',
        px: ['3rem', null, '8rem'],
        alignItems: 'center',
        justifyContent: 'space-between',
        a: { textDecoration: 'underline' },
        fontSize: [clampBuilder(320, 414, 0.8, 1), '1.4rem', '1.4rem'],
        fontWeight: [500, 400],
        transition: 'all 0.5s ease-out',
      }}
    >
      <Text as="p" sx={{ width: ['60vw', 'unset'], lineHeight: 1.25 }}>
        Our website uses cookies to provide you with the best possible experience.
        {/* @ts-ignore */}
        <Link to="/privacy/">Learn More.</Link>
      </Text>
      <Button
        onClick={() => setCookiesMessageDismissed(true)}
        sx={{
          p: 0,
          height: ['2.6rem', '3.6rem'],
          width: ['8.5rem', '11.3rem !important'],
          border: '1px solid white',
          fontSize: ['1rem', '1.2rem'],
          fontWeight: 'medium',
          backgroundColor: 'transparent',
        }}
      >
        Dismiss
      </Button>
    </Container>
  );
};

export default CookiesMessage;
